export default __webpack_public_path__ + "static/media/img-08.4dde38b5.png";